<template>
 <d-row>
      <d-col lg="12">
  <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
    <i class="fa fa-info mx-2"></i>
    <span id="warning">{{ error_msg }}</span>
  </d-alert>

  <d-card class="card-small mb-4">
    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#FF6700"/>
    <!-- Card Header -->
    <d-card-header class="border-bottom">
       <d-button type="button" :disabled="loading" class="btn-accent" @click="save_form" data-toggle="tooltip" data-placement="top" title="Save Form" ><i class="material-icons">save_alt</i> Simpan</d-button>&nbsp;
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form>
              <d-form-row>
               <!-- Full Name && All Nite Prayer -->
                <d-col md="6" :class="{ 'form-group--error' : $v.fullname.$error }">
                  <d-row>
                    <d-col md=6>
                     <label for="feFullName">Nama Lengkap</label>
                     <d-form-input type="text" id="name" placeholder="Nama Lengkap" v-model.trim="$v.fullname.$model" />
                     <div  class="verror" v-if="!loading && !$v.fullname.required">Harap isi kolom ini</div>
                    </d-col>
                    <!-- d-col md=6>
                      <label for="feAllNite">All Nite Prayer 2025
                      </label>
                      <d-checkbox v-model="allnitepray" toggle />
                    </d-col -->
                    <d-col md=6>
                      <label for="feAllDay">One Day Prayer 2026
                      </label>
                      <d-checkbox v-model="alldaypray" toggle />
                    </d-col>
                  </d-row>
                </d-col>

              <!-- mobile phone -->
                <d-col md="6" class="form-group">
                  <d-row>
                    <d-col md=6>
                      <label for="fejid">HP</label>
                      <d-form-input type="text" id="jid" placeholder="Nomor HP" v-model.trim="jid" />
                    </d-col>
                    <d-col md=6>
                      <label for="feNoHP">Tidak ada data no HP
                      </label>
                      <d-checkbox v-model="no_hp" toggle />
                    </d-col>
                  </d-row>
                </d-col>

              </d-form-row>
              <d-form-row>
               <!-- Circle & RFID, Age--->
                <d-col md="6" :class="{ 'form-group--error' : $v.fullname.$error }">
                  <d-row>
                    <d-col md=6>
                     <label for="feCircle">Circle</label>
                     <d-form-input type="text" id="circle" placeholder="Circle" v-model.trim="circle2025" />
                    </d-col>
                    <d-col md=6>
                     <label for="feRfid">RFID</label>
                     <d-form-input type="text" id="rfid" placeholder="RFID" v-model.trim="rfid" />
                    </d-col>
                    <d-col md=6>
                     <label for="feAge">Umur</label>
                     <d-form-input type="text" id="age" placeholder="Umur" v-model.trim="age" />
                    </d-col>
                  </d-row>
                </d-col>

               <!-- Size & Church -->
                <d-col md="6" :class="{ 'form-group--error' : $v.fullname.$error }">
                  <d-row>
                    <d-col md=6>
                     <label for="feSize">Size</label>
                     <d-form-input type="text" id="size" placeholder="Ukuran" v-model.trim="size" />
                    </d-col>
                    <d-col md=6>
                     <label for="feChurch">Gereja</label>
                     <d-form-select v-model="church_id" :options="gkys" style="padding-left:1px" />
                    </d-col>
                  </d-row>
                </d-col>
              </d-form-row>

              <!-- Memo -->
              <d-form-row>
                <d-col md="12" class="form-group">
                <label for="feInputMemo">Memo</label>
                <textarea
                    class="form-control w-100"
                    v-model.trim="memo"
                    placeholder="Memo"
                    rows="3"
                    max-rows="6">
                </textarea>
               </d-col>
              </d-form-row>

            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
      </d-col>
 </d-row>
</template>
<style>
.item {
  display: flex;
  align-items: center;
}

.item-name {
  font-size: 12px;
}
</style>
<script>
import VueElementLoading from 'vue-element-loading';
import { required } from 'vuelidate/lib/validators';
import env from '../../env.vue';

export default {
  components: {
    VueElementLoading,
  },
  name: 'person-info',
  data(){
    return {
      form:'',
      id:'',
      size:'',
      old_jid:'',
      no_hp:false,
      allnitepray:false,
      alldaypray:false,
      fullname:'',
      circle2025:'',
      jid:'',
      memo:'',
      rfid:'',
      age:'',
      created_at:'',
      church_id:'',
      gkys:[],
      loading:false,
      old_data:[],
      error_msg:'',
      show_alert:false,
    }
  },
  validations:{
    fullname:{ required },
    dob:{ required },
    dtype:{ required },
  },
  watch: {
    '$route.query.id'(newId,oldId){
      if (newId!=oldId){
        if ( newId==0 ) this.resetForm();
      }
    },
    no_hp( val ){
       if ( val ) {
          this.old_jid=this.jid;
          if(this.old_jid=='0000000') this.old_jid='';
          this.jid='0000000';
       } else {
          this.jid=this.old_jid;
          this.old_jid='';
       }
    }
  },
  methods: {

    save_form(){
        let ojid=this.jid;
        let dthis=this;        
        let submit=false;
        Object.keys(this.old_data).forEach( key=>{
          if ( JSON.stringify(eval('dthis.'+key))!==JSON.stringify(eval('dthis.old_data.'+key)) ){
            submit=true;
          }
        });
        if(this.fullname==''){
            alert('Harap isi nama lengkap');
            return;
        }
        if (submit){
          this.loading=true;          
          let arr={};
          if (this.jid=='') this.jid='0000000'; 
          if (this.jid.match(/^0000000$/)) this.jid=this.jid+'@'+this.fullname;
          arr={
            fullname:this.fullname,
            jid:this.jid.replace(/^08/,"628"),
            admin:0,
            origin:"",
            size:this.size,
            created_by:0,
            church_id: parseInt(this.church_id) > 0 ? parseInt(this.church_id) :0 ,
            memo: this.memo.toString(),
            allnitepray: this.allnitepray? 1:0,
            alldaypray: this.alldaypray? 1:0,
            circle2025: this.circle2025!='' ? this.circle2025:'',
            rfid: this.rfid.toString(),
            age: this.age=='' ? 0: parseInt(this.age),
          };
          if (this.id===0) this.id='';  
          this.axios.post( env.server+'/person/save/'+this.id, arr
          ).then( resp=>{
            this.jid=ojid;  
            resp=JSON.parse(resp.data);
            this.loading=false;
            if (resp.message=='Duplicate Person'){
              this.pop_alert('Peserta Doa dengan nama dan nomor HP yg diisi sudah ada');
              return;
            }
            if (this.id==0)this.id=resp.data[0];
            this.$buefy.toast.open({ message:'Data berhasil disimpan',
              position: 'is-bottom',
              type: 'is-success',
            });
          }).catch(e=>{
            this.jid=ojid;  
            this.pop_alert(JSON.parse(e.response.data));
            this.loading=false;
          })
        }
    },
    pop_alert(msg){
      if (msg==undefined) return;
      this.$refs.dalert.dismissed=false;
      this.show_alert=5;
      this.error_msg=msg;
    },
    resetForm(){
      var dthis=this;
      this.old_data={ 
      id:'',
      fullname:'',
      jid:'',
      admin:0,
      origin:'mabes',
      size:'',
      created_by:0,
      memo:'',
      allnitepray:0,
      alldaypray:0,
      circle2025:'',
      church_id:{value:'1',text:'GKY - Mangga Besar'},
      rfid:'',
      age:'',
      size:''
      }
      let dgky = this.gkys.filter( (a)=>{ if (a.value==1) return a });
      this.church_id=dgky[0].value;
    },
    loadForm(){
      this.loading=true;
      if ( this.locations==[] || this.organizations==[] ){
        setTimeout(()=>{this.loadForm();},500);
        return;
      }
      this.axios.get( env.server+'/person/load/'+this.id).then(
        resp=>{
          resp.data = JSON.parse(resp.data);
          resp.data = resp.data.data;
          this.fullname=resp.data.fullname;
          this.jid=resp.data.jid.split(/@/)[0];
//          this.size=resp.data.size;
          this.allnitepray=resp.data.allnitepray?true:false;
          this.alldaypray=resp.data.alldaypray?true:false;
          this.circle2025=resp.data.circle2025==0 ? '':resp.data.circle2025;
          this.rfid=resp.data.rfid;
          this.age=resp.data.age;
          this.size=resp.data.size.toUpperCase();
          this.loading=false;
          this.old_data=resp.data,
          this.memo=resp.data.memo;
          let dgky = this.gkys.filter( (a)=>{ if (a.value==resp.data.church_id) return a });
          this.church_id=dgky[0].value;
          
          if (this.jid=='0000000'){this.no_hp=true;this.old_jid='';}
        }
      );
    },
  },
  mounted(){
    this.id=this.$route.query.id;
    this.axios.get( env.server+'/church/all').then( resp=>{
        resp.data = JSON.parse(resp.data);
        let arr=[{text:'',value:0}];
        for(let i=0;i<resp.data.data.length;i++){
           arr.push( { text: resp.data.data[i].name , value: resp.data.data[i].id });
        }
        this.gkys=arr;
        if ( this.id>0 ){
            setTimeout(()=>{this.loadForm();},100);
        } else {
          this.resetForm()
          let arr=this.$store.state.list;
        }
    });
  },
};
</script>
